import { render, staticRenderFns } from "./PaymentRequisitionDetailDrawerOwnerSelector.vue?vue&type=template&id=27388aec&"
import script from "./PaymentRequisitionDetailDrawerOwnerSelector.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionDetailDrawerOwnerSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports